/**
 * Father's Day buy box — preload tiers via GET /api/tiers?tiers=…, checkout clears cart + adds lines.
 */
(function () {
  'use strict';

  var IN_FLIGHT = '__FD_BUY_BOX_CHECKOUT_IN_FLIGHT__';
  var TIER_KEYS = ['connoisseur', 'fathers_day_three_months', 'fathers_day_one_time'];
  var PLAN_TO_TIER = {
    bourbon: 'fathers_day_one_time',
    subscription: 'fathers_day_three_months',
    monthly: 'connoisseur',
  };
  var TIER_FETCH_TIMEOUT_MS = 15000;
  var TIER_FETCH_RETRIES = 2;
  var QUIZ_SESSION_ID_KEY = 'quizSessionId';

  var tiersCachePromise = null;
  var preClearCartPromise = null;
  var preClearStarted = false;

  function isFatherDayPage() {
    try {
      return !!(document.body && document.body.classList.contains('father-day-page'));
    } catch (_) {
      return false;
    }
  }

  function getApiBase() {
    var base = typeof window !== 'undefined' ? window.__QUIZ_API_BASE__ : '';
    return String(base || '').replace(/\/$/, '');
  }

  function normalizeTierEntry(entry) {
    var e = entry && typeof entry === 'object' ? entry : {};
    var rawItems = Array.isArray(e.items) ? e.items : [];
    return rawItems
      .map(function (obj) {
        var i = obj && typeof obj === 'object' ? obj : {};
        var variant = '';
        if (typeof i.variant === 'number' && isFinite(i.variant)) variant = String(Math.trunc(i.variant));
        else if (typeof i.variant === 'string') variant = i.variant.trim();
        var quantity = isFinite(Number(i.quantity)) ? Number(i.quantity) : 0;
        var sellingPlan = '';
        if (typeof i.sellingPlan === 'number' && isFinite(i.sellingPlan)) sellingPlan = String(Math.trunc(i.sellingPlan));
        else if (typeof i.sellingPlan === 'string') sellingPlan = i.sellingPlan.trim();
        var properties = i.properties && typeof i.properties === 'object' ? i.properties : null;
        var role = typeof i._role === 'string' ? i._role.trim() : '';
        if (!variant || quantity <= 0) return null;
        var item = { id: variant, quantity: quantity };
        if (sellingPlan) item.selling_plan = Number(sellingPlan) || sellingPlan;
        if (properties) item.properties = properties;
        if (role) item._role = role;
        var fdRaw = i.flatDiscount;
        if (fdRaw != null && fdRaw !== '') {
          if (typeof fdRaw === 'number' && isFinite(fdRaw)) {
            item.flatDiscount = fdRaw;
          } else if (typeof fdRaw === 'string') {
            var fdTrim = fdRaw.trim();
            if (fdTrim) {
              var fdNum = Number(fdTrim);
              item.flatDiscount = isFinite(fdNum) ? fdNum : fdTrim;
            }
          }
        }
        return item;
      })
      .filter(Boolean);
  }

  function parseTiersBatch(json) {
    var tiers = (json && json.data && json.data.tiers) || (json && json.tiers) || {};
    var out = {};
    TIER_KEYS.forEach(function (key) {
      out[key] = normalizeTierEntry(tiers[key] || {});
    });
    return out;
  }

  function fetchWithTimeout(url, opts, timeoutMs) {
    var nf = window.__TP_ORIG_FETCH__ || fetch;
    var ms = timeoutMs || TIER_FETCH_TIMEOUT_MS;
    if (typeof AbortController === 'undefined') {
      return nf(url, opts);
    }
    var controller = new AbortController();
    var timerId = window.setTimeout(function () {
      controller.abort();
    }, ms);
    return nf(url, Object.assign({}, opts || {}, { signal: controller.signal })).finally(function () {
      window.clearTimeout(timerId);
    });
  }

  function fetchAllTiers() {
    var base = getApiBase();
    if (!base) return Promise.reject(new Error('Quiz API base URL is not set'));
    var url =
      base + '/api/tiers?tiers=' + encodeURIComponent(TIER_KEYS.join(','));

    function requestOnce() {
      return fetchWithTimeout(
        url,
        {
          method: 'GET',
          headers: { Accept: 'application/json' },
          credentials: 'omit',
          mode: 'cors',
          cache: 'no-store',
        },
        TIER_FETCH_TIMEOUT_MS
      )
        .then(function (res) {
          if (!res.ok) throw new Error('Tier API error: ' + res.status);
          return res.json();
        })
        .then(function (json) {
          var tiers = parseTiersBatch(json);
          var missing = TIER_KEYS.filter(function (key) {
            return !tiers[key] || !tiers[key].length;
          });
          if (missing.length) {
            throw new Error('Tier payload missing items for: ' + missing.join(', '));
          }
          return tiers;
        });
    }

    function requestWithRetries(attempt) {
      return requestOnce().catch(function (err) {
        if (attempt >= TIER_FETCH_RETRIES) throw err;
        return new Promise(function (resolve) {
          window.setTimeout(resolve, 400 * (attempt + 1));
        }).then(function () {
          return requestWithRetries(attempt + 1);
        });
      });
    }

    return requestWithRetries(0);
  }

  function preloadTiers() {
    if (tiersCachePromise) return tiersCachePromise;
    tiersCachePromise = fetchAllTiers()
      .then(function (cache) {
        try {
          window.__FD_BUY_BOX_TIERS__ = cache;
        } catch (_) {}
        return cache;
      })
      .catch(function (err) {
        tiersCachePromise = null;
        throw err;
      });
    return tiersCachePromise;
  }

  function getBuyBoxSection() {
    return document.querySelector('.fd-buy-box[data-section="father-day-buy-box"], .fd-buy-box#father-day-buy-box, .fd-buy-box');
  }

  function getSelectedPlan(section) {
    var root = section || getBuyBoxSection();
    if (!root) return 'bourbon';
    var selected = root.querySelector('.fd-buy-box__card--selected[data-fd-plan]');
    return (selected && selected.getAttribute('data-fd-plan')) || 'bourbon';
  }

  function resolveTierKey(section) {
    var root = section || getBuyBoxSection();
    if (root) {
      var selected = root.querySelector('.fd-buy-box__card--selected[data-fd-plan]');
      var tierAttr = selected && selected.getAttribute('data-fd-tier');
      if (tierAttr) return String(tierAttr).trim();
    }
    var plan = getSelectedPlan(section);
    return PLAN_TO_TIER[plan] || 'fathers_day_one_time';
  }

  function getTierItems(tierKey) {
    tierKey = String(tierKey || '').trim();
    return preloadTiers().then(function (cache) {
      var items = cache[tierKey];
      if (!items || !items.length) {
        return Promise.reject(new Error('Tier payload missing items for tier: ' + tierKey));
      }
      return { tierKey: tierKey, items: items.slice() };
    });
  }

  function buildBundleItems(items, bundleId) {
    return items.map(function (item) {
      var itemRole = item._role;
      var flatDiscount = item.flatDiscount;
      var rest = {};
      Object.keys(item).forEach(function (k) {
        if (k !== '_role' && k !== 'flatDiscount') rest[k] = item[k];
      });
      var roleLower = (typeof itemRole === 'string' ? itemRole : '').trim().toLowerCase();
      var properties = Object.assign({}, rest.properties || {}, {
        _bundleId: bundleId,
        _role: itemRole || 'main',
      });
      if (roleLower === 'gift' && flatDiscount != null && flatDiscount !== '') {
        properties._flatDiscount =
          typeof flatDiscount === 'number' && isFinite(flatDiscount)
            ? String(flatDiscount)
            : String(flatDiscount).trim();
      }
      rest.properties = properties;
      return rest;
    });
  }

  function rawFetch(url, opts) {
    opts = opts || {};
    var headers = Object.assign({ Accept: 'application/json' }, opts.headers || {});
    var nativeFetch = window.__TP_ORIG_FETCH__ || fetch;
    return nativeFetch(
      url,
      Object.assign({}, opts, {
        credentials: 'same-origin',
        headers: headers,
      })
    );
  }

  function addFetch(url, opts) {
    opts = opts || {};
    var headers = Object.assign({ Accept: 'application/json' }, opts.headers || {});
    return window.fetch(
      url,
      Object.assign({}, opts, {
        credentials: 'same-origin',
        headers: headers,
      })
    );
  }

  function sortCartLineItemsMainFirst(items) {
    return items.slice().sort(function (a, b) {
      var ra = (a.properties && a.properties._role) || '';
      var rb = (b.properties && b.properties._role) || '';
      if (ra === 'main' && rb !== 'main') return -1;
      if (rb === 'main' && ra !== 'main') return 1;
      return 0;
    });
  }

  function postCartAddJs(items) {
    var sorted = sortCartLineItemsMainFirst(items);
    return addFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: sorted }),
    }).then(function (res) {
      if (res.ok || res.status !== 422 || sorted.length <= 1) return res;
      var mains = sorted.filter(function (it) {
        return (it.properties && it.properties._role) === 'main';
      });
      var gifts = sorted.filter(function (it) {
        return (it.properties && it.properties._role) !== 'main';
      });
      if (!mains.length || !gifts.length) return res;
      return addFetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: mains }),
      }).then(function (resMain) {
        if (!resMain.ok) return resMain;
        return addFetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: gifts }),
        });
      });
    });
  }

  function clearCartBeforeAdd() {
    function doClear() {
      return rawFetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } });
    }
    return doClear()
      .then(function (res) {
        if (!res.ok) return doClear();
        return res;
      })
      .then(function (res) {
        if (!res.ok) throw new Error('/cart/clear.js failed: ' + res.status);
      });
  }

  function getCartState() {
    return rawFetch('/cart.js', { method: 'GET' }).then(function (res) {
      if (!res.ok) throw new Error('/cart.js failed: ' + res.status);
      return res.json();
    });
  }

  function cartHasItems(cart) {
    return Number((cart && cart.item_count) || 0) > 0;
  }

  function startPreClearCart() {
    if (preClearStarted) return;
    preClearStarted = true;
    preClearCartPromise = rawFetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    })
      .then(function (res) {
        return res.ok;
      })
      .catch(function () {
        return false;
      });
  }

  function openCartDrawerWithTimeout(cartJson) {
    var skipDrawer =
      typeof window !== 'undefined' &&
      new URLSearchParams(window.location.search).get('debugCheckout') === '1';
    if (skipDrawer) return Promise.resolve();

    if (window.CartBundleAdd && typeof window.CartBundleAdd.notifyCartUI === 'function') {
      return Promise.race([
        Promise.resolve(window.CartBundleAdd.notifyCartUI(cartJson)).catch(function () {}),
        new Promise(function (resolve) {
          window.setTimeout(resolve, 6000);
        }),
      ]);
    }

    try {
      if (
        typeof window.theme !== 'undefined' &&
        window.theme.pubsub &&
        typeof window.theme.pubsub.publish === 'function' &&
        window.theme.pubsub.PUB_SUB_EVENTS &&
        window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate
      ) {
        window.theme.pubsub.publish(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
          source: 'father-day-buy-box',
          cart: cartJson,
        });
      }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
    } catch (_) {}
    return Promise.resolve();
  }

  function trackPosthog(event, props) {
    try {
      if (window.whiskyPosthog && typeof window.whiskyPosthog.capture === 'function') {
        window.whiskyPosthog.capture(event, window.whiskyPosthog.funnelContext(props || {}));
      }
    } catch (_) {}
  }

  function getCheckoutCta(section) {
    var root = section || getBuyBoxSection();
    return root ? root.querySelector('.fd-buy-box__cta') : null;
  }

  function getCtaTextEl(cta) {
    return cta ? cta.querySelector('.fd-buy-box__cta-text') : null;
  }

  function setCtaLoading(cta, isLoading, statusText) {
    if (!cta) return;
    var textEl = getCtaTextEl(cta);
    if (isLoading) {
      cta.classList.add('fd-buy-box__cta--loading');
      cta.setAttribute('aria-busy', 'true');
      if (statusText && textEl) textEl.textContent = statusText;
    } else {
      cta.classList.remove('fd-buy-box__cta--loading', 'fd-buy-box__cta--error');
      cta.removeAttribute('aria-busy');
      cta.removeAttribute('aria-live');
    }
  }

  function showCtaError(cta, message) {
    if (!cta) return;
    var textEl = getCtaTextEl(cta);
    cta.classList.add('fd-buy-box__cta--error');
    cta.setAttribute('aria-live', 'polite');
    if (textEl && message) textEl.textContent = message;
  }

  function restoreCtaLabel(cta, section) {
    if (!cta) return;
    var textEl = getCtaTextEl(cta);
    var selected = section.querySelector('.fd-buy-box__card--selected[data-fd-plan]');
    if (textEl && selected && selected.dataset.fdCta) {
      textEl.textContent = selected.dataset.fdCta;
    }
  }

  function runCheckout(section) {
    var cta = getCheckoutCta(section);
    var tierKey = resolveTierKey(section);

    trackPosthog('father_day_buy_box_checkout_started', {
      tier_key: tierKey,
      plan: getSelectedPlan(section),
      template_suffix: window._template && window._template.suffix,
    });

    setCtaLoading(cta, true, 'Preparing your cart…');

    return getTierItems(tierKey)
      .then(function (payload) {
        var apiItems = payload.items;
        var bundleId =
          String(payload.tierKey || tierKey).replace(/[^a-z0-9_]+/gi, '_') + '_' + Date.now();
        var mergedWithBundle = buildBundleItems(apiItems, bundleId);

        var quizSessionId = '';
        try {
          quizSessionId = (window.localStorage.getItem(QUIZ_SESSION_ID_KEY) || '').trim();
        } catch (_) {}
        var cartAttributes = {};
        if (quizSessionId) cartAttributes.quizSessionId = quizSessionId;

        var chain = Promise.resolve();
        if (preClearCartPromise) {
          chain = chain.then(function () {
            return preClearCartPromise.catch(function () {});
          });
        }

        return chain
          .then(function () {
            return clearCartBeforeAdd();
          })
          .then(function () {
            var addPromise = postCartAddJs(mergedWithBundle).then(function (res) {
              if (!res.ok) throw new Error('/cart/add.js ' + res.status);
              return res;
            });
            var stampPromise =
              Object.keys(cartAttributes).length > 0
                ? rawFetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ attributes: cartAttributes }),
                  }).catch(function () {})
                : Promise.resolve();
            return Promise.all([addPromise, stampPromise]);
          })
          .then(function () {
            return getCartState();
          })
          .then(function (cartState) {
            if (!cartHasItems(cartState)) {
              throw new Error('Cart still empty after add');
            }
            trackPosthog('father_day_buy_box_added_to_cart', {
              tier_key: tierKey,
              cart_item_count: cartState.item_count,
            });
            setCtaLoading(cta, false);
            restoreCtaLabel(cta, section);
            return openCartDrawerWithTimeout(cartState);
          });
      })
      .catch(function (err) {
        var errMsg = err && err.message ? err.message : String(err);
        trackPosthog('father_day_buy_box_checkout_failed', { error_message: errMsg, tier_key: tierKey });
        console.error('[Father Day buy box checkout]', err);
        setCtaLoading(cta, false);
        if (/abort/i.test(errMsg) || /timed? ?out/i.test(errMsg)) {
          showCtaError(cta, 'Connection timed out. Please try again.');
        } else if (/Tier API/i.test(errMsg) || /missing items/i.test(errMsg)) {
          showCtaError(cta, 'Offer is loading. Please try again.');
        } else if (/cart\/add/i.test(errMsg)) {
          showCtaError(cta, 'Could not add your box. Please try again.');
        } else {
          showCtaError(cta, 'Something went wrong. Please try again.');
        }
        window.setTimeout(function () {
          restoreCtaLabel(cta, section);
        }, 4000);
      })
      .finally(function () {
        window[IN_FLIGHT] = false;
      });
  }

  function onCheckoutActivate(e) {
    var cta = e.target.closest('.fd-buy-box__cta');
    if (!cta || !cta.closest('.fd-buy-box')) return;
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;

    e.preventDefault();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    e.stopPropagation();

    if (window[IN_FLIGHT]) return;
    window[IN_FLIGHT] = true;

    var section = cta.closest('.fd-buy-box');
    runCheckout(section);
  }

  function enableCheckoutCta(section) {
    var cta = getCheckoutCta(section);
    if (!cta) return;
    cta.classList.add('fd-buy-box__cta--ready');
    cta.removeAttribute('aria-disabled');
    if (!cta.getAttribute('role')) cta.setAttribute('role', 'button');
  }

  function initSection(section) {
    if (!section || section.dataset.fdBuyBoxCheckoutInit) return;
    section.dataset.fdBuyBoxCheckoutInit = '1';
    enableCheckoutCta(section);
  }

  function init() {
    if (!isFatherDayPage()) return;

    startPreClearCart();
    preloadTiers().catch(function (err) {
      console.warn('[Father Day buy box] Tier preload failed:', err);
    });

    document.querySelectorAll('.fd-buy-box').forEach(initSection);

    document.addEventListener('click', onCheckoutActivate, true);
    document.addEventListener('keydown', onCheckoutActivate, true);

    window.addEventListener('pageshow', function () {
      window[IN_FLIGHT] = false;
      document.querySelectorAll('.fd-buy-box').forEach(function (section) {
        var cta = getCheckoutCta(section);
        setCtaLoading(cta, false);
        restoreCtaLabel(cta, section);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
